import React, { useContext, useState } from "react";
import { RiCloseCircleFill } from "react-icons/ri";
import signup_bg from "../../Asset/login/signup_bg.jpg";
import { useContact } from "../../useContext/ContactContext";
import authModel from "../../model/auth.model";
import { toast } from "../../lib/helper";
import { useNavigate } from "react-router-dom";

const Signup = ({ setSignup }) => {
  const navigate = useNavigate();
  const { contact, setContact } = useContact();
  const [inputs, setInputs] = useState(["", "", "", ""]);

  const handleChange = (e, index) => {
    const { value } = e.target;

    if (/^\d*$/.test(value)) {
      const newInputs = [...inputs];
      newInputs[index] = value;
      setInputs(newInputs);

      if (value.length === 1 && index < 5) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        if (nextInput) {
          nextInput.focus();
        }
      } else if (value.length === 0 && index > 0) {
        const prevInput = document.getElementById(`otp-input-${index - 1}`);
        if (prevInput) {
          prevInput.focus();
        }
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text");
    if (/^\d{6}$/.test(text)) {
      const newInputs = text.split("");
      setInputs(newInputs);

      const firstInput = document.getElementById(`otp-input-0`);
      if (firstInput) {
        firstInput.focus();
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const otp = inputs.join("");
    const form = new FormData(e.target);
    form.append("otp", otp);
    form.append("contact_no", contact);

    authModel
      .VerifyOtp(form)
      .then((responce) => {
        toast(responce?.data?.message, "success");
        sessionStorage.setItem("token", responce?.data?.access_token);
        sessionStorage.setItem("user", JSON.stringify(responce?.data?.userData));
        setTimeout(() => {
          window.location.reload();
        }, 500);
        setSignup(false);
        toast(responce?.data?.message, "success");
        console.log("responce regis", responce);
      })
      .catch((error) => {
        console.log(error?.response?.data?.error_message,"warning");
       toast(error?.response?.data?.message, "warning");
      });
  };
  return (
    <div className="w-full fixed inset-0 bg-black/50 flex justify-center items-center overflow-y-auto">
      <div
        className="h-[650px] w-11/12 sm:w-4/5 sm:h-[900px] md:w-1/4 lg:w-1/4 xl:w-1/4 md:h-[400px] lg:h-[540px] xl:h-[600px] 2xl:h-[750px]   2xl:w-1/4  rounded-3xl bg-cover bg-center bg-no-repeat px-6 2xl:px-8 md:px-2 py-12 md:py-7"
        style={{ backgroundImage: `url(${signup_bg})` }}
      >
        <div className="bg-white/50 relative rounded-3xl   w-full h-full flex items-end ">
          <div className="p-4  md:p-3 sm:p-6 xl:p-4 lg:p-5 2xl:p-8 absolute top-0 w-full ">
            <div className="">
              <div className="flex justify-between  items-center">
                <span className="text-xl font-bold sm:text-3xl lg:text-xl md:text-base">
                  Sign Up
                </span>
                <RiCloseCircleFill
                  className="text-white text-4xl lg:text-3xl md:text-xl cursor-pointer hover:text-red-500"
                  onClick={() => {
                    setSignup(false);
                  }}
                />
              </div>
            </div>
          </div>
          <form
            onSubmit={handleSubmit}
            className="w-full px-5 sm:px-7 md:px-0 xl:px-2 lg:px-2 2xl:px-4"
          >
            <div className="w-full flex flex-col gap-4 sm:gap-6  md:gap-2 xl:gap-3 lg:gap-4 2xl:gap-6">
              <input
                type="email"
                name="email"
                placeholder="Email"
                className="w-full p-2 sm:p-4 md:p-0.5 lg:p-1 2xl:p-2 border rounded-md"
              />
              <input
                type="text"
                name="name"
                placeholder="Write Full Name"
                className="w-full p-2 sm:p-4 md:p-0.5 lg:p-1 2xl:p-2 border rounded-md"
              />
              <input
                type="number"
                name="age"
                placeholder="Age"
                className="w-full p-2 sm:p-4 md:p-0.5 lg:p-1 2xl:p-2 border rounded-md"
              />
              <div className="flex gap-4 w-full">
                <label className="flex-1 flex items-center gap-2 border bg-white p-2 sm:p-4 md:p-0.5 lg:p-1 2xl:p-2 rounded-md cursor-pointer">
                  <input
                    type="radio"
                    name="gender"
                    value="male"
                    className="border rounded-md"
                  />
                  <span>Male</span>
                </label>
                <label className="flex-1 flex items-center gap-2 bg-white border sm:p-4 2xl:p-2 p-2 md:p-0.5 lg:p-1 rounded-md cursor-pointer">
                  <input
                    type="radio"
                    name="gender"
                    value="female"
                    className="border rounded-md"
                  />
                  <span>Female</span>
                </label>
              </div>
              <div>
                <span className="text-xs  text-center sm:text-lg md:text-[7px] xl:text-xs lg:text-[10px] 2xl:text-base">
                  An OTP sent to +91 {contact}, enter to verify
                </span>
              </div>
              <div className="flex items-center justify-between px-0 sm:px-5 md:px-2 lg:px-2">
                {inputs.map((value, index) => (
                  <input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={value}
                    className="w-14 h-14 sm:w-20 sm:h-20 md:w-6 md:h-6 lg:w-10 lg:h-10 xl:w-12 2xl:w-16 2xl:h-16 xl:h-12 rounded-lg text-center text-sm md:text-2xl font-extrabold text-gray-900 bg-white border border-transparent hover:border-gray-200 appearance-none  p-2 sm:p-4 outline-none focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 shadow-md"
                    maxLength={1}
                    onChange={(e) => handleChange(e, index)}
                    onPaste={handlePaste}
                  />
                ))}
              </div>
              <div className="w-full mt-5 mb-6 sm:mb-8 md:mt-2 md:mb-2 lg:mb-5 xl:mb-4 lg:mt-2 xl:mt-3 2xl:mb-10 2xl:mt-8">
                <button
                  className="w-full bg-textColor text-white py-2  sm:py-3 md:py-0.5 lg:py-1 2xl:py-2 rounded-3xl"
                  type="submit"
                >
                  Verify & Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Signup;
